<template>
  <div>
    <!-- 基金选择( 基金交易时 ) -->
    <div class="wk-input wk-input-box dropDown-fund-box posi-relative">
      <span class="input-left-label">{{label}}</span>
      <!--下拉框的 显示框-->
      <div class="dropDown-title dropDown-fund posi-relative" :class="{readonly:readonly===''}" @click="titleCliCk">
        <!-- 如果已经选择的某个基金 -->
        <p v-if="fundInfo.fundCode" class="dropDown-title-fundName ft-size-16 dropDown-fund" :data-id="id">
          {{fundInfo.fundName}}&nbsp;&nbsp;{{fundInfo.fundCode}}
        </p>
        <!-- 否则 未选择 提示请选择基金 -->
        <p v-else class="dropDown-title-placeholder ft-size-16 dropDown-fund" :data-id="id">请选择{{label}}</p>
        <!-- 在 readonly 下 启用 -->
        <p v-if="readonly===''" class="disabled posi-absolute"></p>
        <!-- 尾部 三角号 icon -->
        <p class="posi-absolute dropDown-title-sanjiao dropDown-fund" :data-id="id">
          <img src="../../assets/img/dropdow-icon.png" class="dropDown-title-sanjiao dropDown-fund" :data-id="id">
        </p>
      </div>
      <!--下拉框的选项-->
      <ul v-if="isShowBox" class="dropDown-item-list posi-absolute dropDown-fund" :style="styleCpt" :data-id="id">
        <li v-for="(item,k) in fundList" @click="itemClick(k,item)" :key='k' :class="{active:k===fundIndex}"
          class="dropDown-item">
          <p class="dropDown-item flex-jf-btw">
            <span>{{item.fundName}} </span>
            <span>{{item.fundCode}} </span>
          </p>
        </li>
        <!-- <li v-if="ZDshowMore" style="line-height: 2rem;text-align: center;">
          <span style="padding: 0.3rem 2rem;background: red;    color: #fff;border-radius: 4px;"
            @click="isShowMinRisk = true">查看更多</span>
        </li> -->
        <li v-if="showMore" style="line-height: 2rem;text-align: center;">
          <span style="padding: 0.3rem 2rem;background: red;color: #fff;border-radius: 4px;"
            @click="isShowRiskTip=true">查看更多</span>
        </li>
        <li v-if="fundList.length < 1" class="dropDown-item flex-jf-center no-data">
          <p class="dropDown-item "> 暂无数据 </p>
        </li>
      </ul>
    </div>
    <!--风险等级提示 弹框提示-->
    <div class="model-container animated-5 fadeIn transRiskTip" v-if="isShowRiskTip">
      <div class="model-box posi-relative">
        <p class="model-title flex-jf-btw">
          <span class="mdl-title">风险等级不匹配提示</span>
          <span @click="isShowRiskTip=false">X</span>
        </p>
        <!-- 主要内容 -->
        <div class="model-content">
          <div class="txt-center">您即将查看的基金产品风险等级高于您的风险承受能力<br>是否继续查看？</div>
          <div class="txt-center">
            <btn-middle @click="isShowRiskTip=false" classCpt="btn-free">放弃购买</btn-middle>
            <btn-middle @click="fundList = ResetfundList,isShowRiskTip=false,showMore=false" classCpt="">继续查看
            </btn-middle>
          </div>
        </div>
      </div>
    </div>
    <!--风险等级提示 (C1最低时,提示去风测)-->
    <div class="model-container animated-5 fadeIn transRiskTip" v-if="isShowMinRisk">
      <div class="model-box posi-relative" style="width: 19rem;">
        <p class="model-title flex-jf-btw">
          <span class="mdl-title">风险等级不匹配提示</span>
          <span @click="isShowMinRisk=false">X</span>
        </p>
        <!-- 主要内容 -->
        <div class="model-content">
          <div class="txt-left">
            您当前风险等级为C1(风险承受能力最低类别)，属于最低风险承受能力的投资者，
            根据适当性匹配原则和相关法规要求仅可购买我司风险等级为R1(低风险)的产品，
            无法购买风险等级为R2(中低风险)、R3(中风险)、R4(中高风险)、R5(高风险)的产品。
          </div>
          <div class="txt-center">
            <btn-middle @click="isShowMinRisk=false" classCpt="btn-free">放弃购买</btn-middle>
            <btn-middle
              @click="isShowMinRisk=false,$router.push({path:'/fengxianceping'}),$tools.setSession('Fxpc_url', 'Myccjj')">
              去风险评测
            </btn-middle>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'id', 'styleCpt', 'readonly', 'dataList','fundAllList'],
    mounted() {
      this.initHandler(this);
    },
    data() {
      return {
        fundList: '',
        ResetfundList: '',
        lineList:'',
        fundInfo: '',
        fundIndex: '',
        isShowBox: false,
        limitTxt: '', //限额提示
        isShowLimit: false, //是否想显示限额
        isShowMinRisk: false, //最低风险等级
        isShowRiskTip: false, //风险等级不匹配
        ZDshowMore: false, //查看更多
        showMore: false, //查看更多
      }
    },
    watch: {
      value() {
        // 一般是回显会用到
        if (this.fundInfo === '' && this.fundList) {
          this.showSltfund(this);
        }
      },
      dataList() {
        if(this.dataList !==''){
            this.initHandler(this);
        }
        if (this.dataList.length > 0 && this.readonly === '') {
            this.itemClick(0);
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('click', this.windowHanlderOffund);
    },
    methods: {
      // title 单击事件
      titleCliCk() {
        this.isShowBox = !this.isShowBox;
      },
      // 基金选择事件
      itemClick(k,item) {
        this.fundIndex = k;
        this.fundInfo = this.fundList[k];
        this.isShowBox = false;
        this.$emit('input', this.fundInfo);
        this.$emit('change', item);
      },
      // 清空已选择的值
      clearSltVal() {
        this.fundIndex = '';
        this.fundInfo = '';
      },
      // window 点击事件
      windowHanlderOffund(e) {
        let target = e.target;
        
        if(!e.target.attributes['data-id']){
            this.isShowBox = false;
        }else if(e.target.attributes['data-id'].nodeValue != this.id){
            this.isShowBox = false;
        }

        // 如果点击的 不是 title 和 item 都隐藏
        // if (target.className.indexOf('dropDown-fund') < 0) {
        //   this.isShowBox = false;
        // }
      },

      getInfoList(){
        this.dataList ? this.fundList = this.dataList : this.fundList = [];
        this.ResetfundList = this.fundAllList || this.dataList;
        var newsdataList = this.dataList;
        var nulldataList = [];

        if (this.dataList == '') {
          this.showMore = false;
          this.ZDshowMore == false;
          this.fundList = [];
        } else {
          this.fundList = this.dataList
          // 如果是 C3 及 以上 或 注册用户可查看所有基金  则显示全部基金并不显示加载更多的按钮
          if (this.$store.state.userInfo.riskAbility >= 3 || this.$store.state.userInfo.userType < 2) {
            this.ZDshowMore == false;
            this.fundList = this.dataList;
            this.lineList = nulldataList;
            this.showMore = false;
          } else if (this.$store.state.userInfo.minRiskFlag == 1 && 
                    this.$store.state.userInfo.riskAbility == 1) { //如果是 c1 最低风险等级 ,则只能展示 货币型
            for (const key in newsdataList) {
                 
              if (newsdataList[key].fundType == '2' || newsdataList[key].riskLevel == '0') {
                nulldataList.push(newsdataList[key])
              }
            }
           
            this.fundList = nulldataList;
            this.lineList = nulldataList;
            //筛选出 货币基金
            // this.ZDshowMore = true;
            this.showMore = true;
          } else if (this.$store.state.userInfo.riskAbility < 3) {
            this.showMore = true;
            // 筛选出 符合自己 可查看的 基金信息
            //C1 最高可查看 R1 , C2 最高可查看 R2 ... 依次类推
            // newsdataList.map((item,index) => {
            //     if(this.$store.state.userInfo.riskAbility  >= (item.riskLevel+1)){
            //        nulldataList.push(item)
            //     } 
            // })
            for (const key in newsdataList) {
              if (this.$store.state.userInfo.riskAbility >= (newsdataList[key].riskLevel + 1)) {
                nulldataList.push(newsdataList[key])
              }
            }
            this.fundList = nulldataList;
            this.lineList = nulldataList;
            //筛选出 货币基金
          }
        }
      },
      // 页面初始化数据
      initHandler(that) {
        that.getInfoList(that);
        // 绑定 window 事件
        window.addEventListener('click', this.windowHanlderOffund);
      },
      // 显示的默认选中的基金卡信息
      showSltfund(that) {
        if (that.value) {
          // 遍历出当前的 默认选中的 基金卡信息
          that.fundList.map((val, k) => {
            if (val.fundCode == that.value.fundCode) {
              that.fundIndex = k;
              that.fundInfo = val;
              //跟新 当前基金卡的 开户方式
              that.$store.commit('upfundInfo', {
                capitalInfoList: val.capitalInfoList
              })
            }
          })
        }
      }
    }
  }

</script>

<style scoped lang="less">
  .dropDown-fund-box {
    margin: .9rem 0;

    // 下拉框的 title
    .dropDown-title {
      width: 17.3rem;
      height: 2.1rem;
      padding: 0 .8rem;
      line-height: 2rem;
      border: 1px solid #d1d1d1;
      cursor: pointer;

      // 未选择时提示
      .dropDown-title-placeholder {
        color: #cacaca;
      }

      // 已选择的基金 名称
      .dropDown-title-fundName {
        position: absolute;
        top: 0;
        left: .8rem;
        right: 0;
      }

      // 已选择的基金 icon
      .dropDown-title-icon {
        max-width: 1.2rem;
        margin-top: .4rem;
      }

      // readonly 下启用
      p.disabled {
        top: 0;
        right: 0;
        width: 18.4rem;
        height: 2rem;
        background: rgba(245, 247, 250, .1);
        z-index: 3;
      }

      // 三角号的icon
      p:last-child {
        top: 0;
        right: 0;
        bottom: 0;
        width: 2rem;
        background: #F8F8F8;
        border-left: .05rem solid #D6D6D6;
        text-align: center;
      }
    }

    // 下拉选择项
    .dropDown-item-list {
      top: 2.5rem;
      right: -1.1rem;
      width: 19.6rem;
      min-height: 2.1rem;
      max-height: 200px;
      padding: 0 0 0;
      flex-wrap: wrap;
      background: #fff;
      box-shadow: 0 2px 9px 0 rgba(205, 200, 200, 0.48);
      overflow: auto;
      z-index: 200000;

      li {
        height: 2rem;
        padding: 0 .5rem;
        margin: 0 0 0 0;
        border: .05rem solid transparent;
        border-left: .05rem solid #D1D1D1;
        border-right: .05rem solid #D1D1D1;
        cursor: pointer;
        transition: all .5s linear;

        // 基金 icon
        p:first-child {
          padding-right: .3rem;

          img {
            max-width: 1.2rem;
            margin-top: .55rem;
          }
        }

        // 基金 名称
        p:last-child {
          line-height: 2rem;
        }
      }

      li+li,
      li:first-child {
        border-top: .05rem solid #D1D1D1;
      }

      li:last-child {
        border-bottom: .05rem solid #D1D1D1;
      }

      li:nth-child(3n) {
        margin-right: 0;
      }

      li.no-data,
      li.no-data:hover {
        background: #f5f5f5 !important;
        color: #999;
        border: .05rem solid #D1D1D1;
      }

      li:hover,
      li.active {
        border: .05rem solid #DD867E;
        background: #FFF0EE;
      }

      li:hover+li,
      li.active+li {
        border-top: .05rem solid transparent;
      }
    }

    // readonly 模式下的 背景颜色
    .readonly {
      background: #F5F7FA;
    }
  }

</style>
<style lang="less">
  .container-two .dropDown-fund-box {
    .dropDown-item-list {
      right: -2.3rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelectFundsnews.vue